import React from 'react';

import styled from 'styled-components';

import { WeatherData } from 'libs/types';
import { MEDIA_SIZE_LIST } from 'libs/const';

const WeatherIconBox = styled.div`
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const WeatherValue = styled.span<{ isBad?: boolean }>`
  color: ${(props) => (props.isBad ? props.theme.skyw.badColor : '#ffffff')};
  font-size: 26px;
  font-weight: 600;

  span:last-child {
    font-size: 20px;
    margin-left: 6px;
  }
`;

const WeatherInfo = styled.div`
  flex: 1;
  border-right: 1px solid #606060;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${(props) => props.theme.skyw.mainColor1};
  font-size: 13px;
  font-weight: 600;

  &:first-child {
    border-left: 1px solid #606060;
  }
`;

const Container = styled.div`
  display: flex;
  padding-left: 50px;
  padding-right: 20px;

  @media screen and (max-width: ${`${MEDIA_SIZE_LIST[0]}px`}) {
    padding-left: 40px;
    padding-right: 18px;

    ${WeatherInfo} {
      font-size: 10px;
      img {
        transform: scale(0.8);
      }
    }
    ${WeatherValue} {
      font-size: 18px;

      span:last-child {
        font-size: 14px;
        margin-left: 2px;
      }
    }
  }

  @media screen and (max-width: ${`${MEDIA_SIZE_LIST[1]}px`}) {
    padding: 0;
    margin-bottom: 10px;
    ${WeatherInfo} {
      font-size: 10px;
    }
    ${WeatherValue} {
      font-size: 18px;

      span:last-child {
        font-size: 14px;
        margin-left: 2px;
      }
    }
  }
`;

interface WeatherTableProps {
  t: WeatherData;
  h: WeatherData;
  w: WeatherData;
  c: WeatherData;
}

const WeatherTable = ({ t, h, w, c }: WeatherTableProps) => {
  return (
    <Container>
      <WeatherInfo>
        <WeatherIconBox>
          <img src="/assets/skyw/table_t_icon.png" alt="icon" />
        </WeatherIconBox>
        <span>TEMPERATURE</span>
        <WeatherValue isBad={t[1] === 'N'}>
          <span>{t[0] === 'N/A' ? '-' : t[0]}</span>
          {t[0] !== 'N/A' && <span>°C</span>}
        </WeatherValue>
      </WeatherInfo>
      <WeatherInfo>
        <WeatherIconBox>
          <img src="/assets/skyw/table_h_icon.png" alt="icon" />
        </WeatherIconBox>
        <span>HUMIDITY</span>
        <WeatherValue isBad={h[1] === 'N'}>
          <span>{h[0] === 'N/A' ? '-' : h[0]}</span>
          {h[0] !== 'N/A' && <span>%</span>}
        </WeatherValue>
      </WeatherInfo>
      <WeatherInfo>
        <WeatherIconBox>
          <img src="/assets/skyw/table_c_icon.png" alt="icon" />
        </WeatherIconBox>
        <span>CLOUD</span>
        <WeatherValue isBad={c[1] === 'N'}>
          <span>{c[0] === 'N/A' ? '-' : c[0]}</span>
          <span></span>
        </WeatherValue>
      </WeatherInfo>
      <WeatherInfo>
        <WeatherIconBox>
          <img src="/assets/skyw/table_w_icon.png" alt="icon" />
        </WeatherIconBox>
        <span>WIND SPEED</span>
        <WeatherValue isBad={w[1] === 'N'}>
          <span>{w[0] === 'N/A' ? '-' : w[0]}</span>
          {w[0] !== 'N/A' && <span>m/s</span>}
        </WeatherValue>
      </WeatherInfo>
    </Container>
  );
};

export default React.memo(WeatherTable);
